import { useEffect } from 'react';

const MetaPixel = () => {
  useEffect(() => {
    // Создаем функцию инициализации
    const initializePixel = () => {
      if (window.fbq) return;
      
      const n = window.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    };

    // Загружаем скрипт Facebook Pixel
    const loadPixelScript = () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    };

    // Инициализируем пиксель
    initializePixel();
    loadPixelScript();

    // Инициализируем с ID
    window.fbq('init', '1317951552820583');
    // Отслеживаем просмотр страницы
    window.fbq('track', 'PageView');
  }, []);

  return (
    <noscript>
      <img 
        height="1" 
        width="1" 
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=1317951552820583&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
};

export default MetaPixel; 